var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _vm.formItemKey == "buyerRemarks"
            ? _c(
                "el-form-item",
                { attrs: { label: "", prop: "buyerRemarks" } },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      placeholder: _vm.$t("OrdinaryOrderMix.EditRemarks.buyer"),
                      maxlength: _vm.MAX_LENGTH.PRIORITY,
                      "show-word-limit": "",
                      clearable: "",
                      rows: "5",
                      required: "",
                    },
                    model: {
                      value: _vm.form.buyerRemarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "buyerRemarks", $$v)
                      },
                      expression: "form.buyerRemarks",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.formItemKey == "orderRemarks"
            ? _c(
                "el-form-item",
                { attrs: { label: "", prop: "orderRemarks" } },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      placeholder: _vm.$t(
                        "OrdinaryOrderMix.EditRemarks.merchant"
                      ),
                      maxlength: _vm.MAX_LENGTH.PRIORITY,
                      "show-word-limit": "",
                      clearable: "",
                      rows: "5",
                      required: "",
                    },
                    model: {
                      value: _vm.form.orderRemarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "orderRemarks", $$v)
                      },
                      expression: "form.orderRemarks",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.formItemKey == "serviceRemarks"
            ? _c(
                "el-form-item",
                { attrs: { label: "", prop: "serviceRemarks" } },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      placeholder: _vm.$t(
                        "OrdinaryOrderMix.EditRemarks.customer"
                      ),
                      maxlength: _vm.MAX_LENGTH.PRIORITY,
                      "show-word-limit": "",
                      clearable: "",
                      rows: "5",
                      required: "",
                    },
                    model: {
                      value: _vm.form.serviceRemarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "serviceRemarks", $$v)
                      },
                      expression: "form.serviceRemarks",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.confirmEditRemarks },
            },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }